import React from "react";
import l from "components/util/l";
import PermissionGridField from "components/util/helpers/user/permissions/PermissionField";
import { PERMISSIONS } from "components/util/permissions";

const CollectionPermissionField = ({
  flowId,
  onlyAdminRoles,
  values,
  setFieldValue,
  setValues
}) =>
  <PermissionGridField
    flowId={flowId}
    onlyAdminRoles={onlyAdminRoles}
    fields={[
      {
        name: PERMISSIONS.COLLECTIONS_SHOW_VIEW,
        label: l("Ver registros%CA041"),
        dependancies: [
          PERMISSIONS.COLLECTIONS_SHOW_ADD,
          PERMISSIONS.COLLECTIONS_SHOW_DELETE,
          PERMISSIONS.COLLECTIONS_MODIFY_STRUCTURE
        ]
      },
      {
        name: PERMISSIONS.COLLECTIONS_SHOW_ADD,
        label: l("Editar registros%CA042"),
        parent: PERMISSIONS.COLLECTIONS_SHOW_VIEW
      },
      {
        name: PERMISSIONS.COLLECTIONS_SHOW_DELETE,
        label: l("Eliminar registros%CA043"),
        parent: PERMISSIONS.COLLECTIONS_SHOW_VIEW
      },
      {
        name: PERMISSIONS.COLLECTIONS_MODIFY_STRUCTURE,
        label: l("Modificar estructura%CA167"),
        parent: PERMISSIONS.COLLECTIONS_SHOW_VIEW
      },
    ]}
    values={values}
    setFieldValue={setFieldValue}
    setValues={setValues}
  />

export default CollectionPermissionField;